import { Share } from 'tabler-icons-react';
import {
  ECOM_WEBSTORE_SECTION_BLOCK_TYPE_ENUM,
  HEADING_SIZE_STYLE_ENUM,
  INPUT_CONTROL_TYPE_ENUM
} from '../../../../../config/constants';
import WsShareButtons from './WsShareButtons';

const configNameValues = {
  heading: 'heading',
  headingSize: 'headingSize',
  showIcons: 'showIcons',
  maxIconsShown: 'maxIconsShown',
  iconSize: 'iconSize',
  shareButtonFlow: 'shareButtonFlow',
  topPadding: 'topPadding',
  bottomPadding: 'bottomPadding'
};

const configDefaultValues = {
  [configNameValues.heading]: 'Share to socials!',
  [configNameValues.headingSize]: HEADING_SIZE_STYLE_ENUM.MEDIUM,
  [configNameValues.showIcons]: 'true',
  [configNameValues.maxIconsShown]: '4',
  [configNameValues.iconSize]: '26',
  [configNameValues.shareButtonFlow]: 'model',
  [configNameValues.topPadding]: '0',
  [configNameValues.bottomPadding]: '0'
};

const configOptions = {
  heading: {
    type: INPUT_CONTROL_TYPE_ENUM.TEXT_INPUT,
    label: 'Heading',
    isTextArea: true
  },
  headingSize: {
    label: 'Heading size',
    type: INPUT_CONTROL_TYPE_ENUM.DROP_DOWN,
    options: [
      {
        value: HEADING_SIZE_STYLE_ENUM.SMALL,
        label: 'Small'
      },
      {
        value: HEADING_SIZE_STYLE_ENUM.MEDIUM,
        label: 'Medium'
      },
      {
        value: HEADING_SIZE_STYLE_ENUM.LARGE,
        label: 'Large'
      },
      {
        value: HEADING_SIZE_STYLE_ENUM.EXTRA_LARGE,
        label: 'Extra large'
      },
      {
        value: HEADING_SIZE_STYLE_ENUM.HUGE,
        label: 'Huge'
      }
    ]
  },
  [configNameValues.showIcons]: {
    label: 'Show icons',
    type: INPUT_CONTROL_TYPE_ENUM.CHECKBOX
  },
  [configNameValues.maxIconsShown]: {
    label: 'Maximum icons shown',
    type: INPUT_CONTROL_TYPE_ENUM.SLIDER,
    min: 1,
    max: 8,
    isVisible: (c) => c.showIcons === 'true'
  },
  [configNameValues.iconSize]: {
    label: 'Icon size',
    type: INPUT_CONTROL_TYPE_ENUM.SLIDER,
    min: 20,
    max: 60,
    isVisible: (c) => c.showIcons === 'true'
  },
  [configNameValues.shareButtonFlow]: {
    label: 'Share button flow',
    type: INPUT_CONTROL_TYPE_ENUM.BUTTON_GROUP,
    options: [
      { value: 'model', label: 'Model' },
      { value: 'menu', label: 'Dropdown' }
    ]
  },
  [configNameValues.topPadding]: {
    label: 'Top padding',
    type: INPUT_CONTROL_TYPE_ENUM.SLIDER,
    category: 'Container layout',
    min: 0,
    max: 20,
    unit: 'px'
  },
  [configNameValues.bottomPadding]: {
    label: 'Bottom Padding',
    type: INPUT_CONTROL_TYPE_ENUM.SLIDER,
    category: 'Container layout',
    min: 0,
    max: 20,
    unit: 'px'
  }
};

const config = {
  title: 'Share buttons',
  type: ECOM_WEBSTORE_SECTION_BLOCK_TYPE_ENUM.SHARE_BUTTONS,
  icon: Share,
  Component: WsShareButtons,
  configOptions,
  defaultConfig: configDefaultValues
};

export { config, configOptions, configNameValues, configDefaultValues };
